module.exports = __webpack_public_path__ + "static/assets/58a85d2a2e017c3d519aed798e504ce6.png";